<div class="login-page">
  <div class="login-card">
    <div class="login-logo">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
        <path d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5M.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5m15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0z"/>
      </svg>
      <span class="login-logo-text">SafeScan</span>
    </div>

    <form class="login-form" (ngSubmit)="loginUser()">
      <div class="ss-form-group">
        <label class="ss-label">Username</label>
        <input class="ss-input" type="text" [(ngModel)]="username" name="username" placeholder="Enter username" autocomplete="username" />
      </div>

      <div class="ss-form-group">
        <label class="ss-label">Password</label>
        <input class="ss-input" type="password" [(ngModel)]="password" name="password" placeholder="Enter password" autocomplete="current-password" />
      </div>

      <div class="login-error" *ngIf="errorMessage">{{ errorMessage }}</div>

      <button type="submit" class="login-submit" [disabled]="loading">
        {{ loading ? 'Signing in…' : 'Sign in' }}
      </button>
    </form>

    <div class="login-support">
      Need help? <a href="https://www.safescan.cloud/support">Contact support</a>
    </div>
  </div>
</div>
<div class="sidebar-version">{{ version }}</div>
